import React, { useState, useEffect } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
  Button,
  Backdrop,
  CircularProgress
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../../services/axios';

// Importa as abas
import CadastroTab from './CadastroTab';
import ItensNotaFiscalTab from './ItensNotaFiscalTab';
import ParcelasTab from './ParcelasTab';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

export default function EstNotaFiscalEntradaEdit() {
  const { id } = useParams();   // Se tiver "id", é edição; se não, é criação
  const navigate = useNavigate();
  
  // Estado para controlar qual aba está selecionada
  const [tabIndex, setTabIndex] = useState(0);
  // Estado para indicar carregamento (ex.: ao buscar/atualizar)
  const [loading, setLoading] = useState(false);

  // Estado principal da NF de Entrada (contém tudo de Cadastro, Itens, Parcelas)
  const [notaFiscalEntrada, setNotaFiscalEntrada] = useState({
    // Exemplo de campos do "Cadastro"
    fornecedor: '',         // ID ou nome do fornecedor
    naturezaOperacao: '',   // ID ou descrição
    tipoDocumento: '',
    numeroNotaFiscal: '',
    serieNotaFiscal: '',
    dataEmissao: '',
    dataMovimento: '',
    valorTotalNotaFiscal: 0,
    status: 'ABERTO', // Ex.: se tiver enum

    // Itens (array de objetos)
    itens: [],

    // Parcelas (array de objetos)
    parcelas: []
  });

  // Ao montar, se "id" existir, busca a NF do backend para edição
  useEffect(() => {
    if (id) {
      setLoading(true);
      axios
        .get(`/api/EstNotaFiscalEntradas/${id}`)
        .then((response) => {
          // Aqui depende de como a API retorna. Ajuste se necessário
          setNotaFiscalEntrada(response.data);
        })
        .catch((error) => {
          console.error(error);
          alert('Erro ao carregar dados da Nota Fiscal de Entrada!');
        })
        .finally(() => setLoading(false));
    }
  }, [id]);

  // Lida com troca de abas
  const handleChangeTab = (event, newValue) => {
    setTabIndex(newValue);
  };

  // Botão SALVAR: faz POST (criar) ou PUT (atualizar)
  const handleSave = async () => {
    try {
      setLoading(true);

      if (!notaFiscalEntrada.fornecedor) {
        alert('Fornecedor é obrigatório!');
        return;
      }
      // Outras validações (ex.: datas)...

      if (!id) {
        // Criando nova NF
        await axios.post('/api/EstNotaFiscalEntradas', notaFiscalEntrada);
        alert('Nota Fiscal de Entrada criada com sucesso!');
      } else {
        // Atualizando a NF existente
        await axios.put(`/api/EstNotaFiscalEntradas/${id}`, notaFiscalEntrada);
        alert('Nota Fiscal de Entrada atualizada com sucesso!');
      }

      // Retorna / vai para listagem
      navigate('/notas-entrada'); // Ajuste a rota conforme seu projeto
    } catch (error) {
      console.error(error);
      alert('Erro ao salvar Nota Fiscal de Entrada!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 1200, margin: '0 auto', p: 2 }}>
      {/* BACKDROP (carregando) */}
      <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 9999 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Typography variant="h5" align="center" gutterBottom>
        {id ? 'Editar Nota Fiscal de Entrada' : 'Nova Nota Fiscal de Entrada'}
      </Typography>

      <Paper sx={{ p: 2 }}>
        {/* Aba (Tabs) */}
        <Tabs value={tabIndex} onChange={handleChangeTab}>
          <Tab label="Cadastro" />
          <Tab label="Itens" />
          <Tab label="Parcelas" />
        </Tabs>

        {/* PAINEL 1: Cadastro */}
        <TabPanel value={tabIndex} index={0}>
          <CadastroTab
            notaFiscalEntrada={notaFiscalEntrada}
            setNotaFiscalEntrada={setNotaFiscalEntrada}
          />
        </TabPanel>

        {/* PAINEL 2: Itens da Nota */}
        <TabPanel value={tabIndex} index={1}>
          <ItensNotaFiscalTab
            itens={notaFiscalEntrada.itens}
            setItens={(novoArray) =>
              setNotaFiscalEntrada((prev) => ({ ...prev, itens: novoArray }))
            }
          />
        </TabPanel>

        {/* PAINEL 3: Parcelas */}
        <TabPanel value={tabIndex} index={2}>
          <ParcelasTab
            parcelas={notaFiscalEntrada.parcelas}
            setParcelas={(novoArray) =>
              setNotaFiscalEntrada((prev) => ({ ...prev, parcelas: novoArray }))
            }
          />
        </TabPanel>

        {/* BOTÕES FINAIS */}
        <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="contained" color="inherit" onClick={() => navigate('/entrada')}>
            Cancelar
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            Salvar
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
